/**
 * Legal policy links shown on the public payment page footer.
 *
 * The documents themselves are vendored, self-contained HTML files served
 * as static assets (see apps/web/public/) and rendered at clean routes via
 * an <iframe> — see src/routes/privacy.tsx and src/routes/terms.tsx.
 *
 * Kept as a single constant so the URLs are trivial to change if the
 * document location or hosting approach ever changes.
 */
export const TERMS_OF_SERVICE_URL = '/terms';
export const PRIVACY_POLICY_URL = '/privacy';
